/**
 * Ensure SF2 runtime banks used by instruments are loaded into an engine.
 */
import type { Instrument } from "../types";
import type { AudioEngine } from "./engine";
import { loadSf2RuntimeBank } from "../sf2/loadBank";

export async function pushSf2BanksForInstruments(
  engine: AudioEngine,
  instruments: Instrument[],
): Promise<void> {
  const fontIds = new Set<string>();
  for (const instrument of instruments) {
    if (instrument?.kind === "sf2") {
      fontIds.add(instrument.patch.fontId);
    }
  }
  for (const fontId of fontIds) {
    const bank = await loadSf2RuntimeBank(fontId);
    engine.transport.loadSf2Bank(fontId, bank);
  }
}
